export default "__VITE_ASSET__utzVEx8tbsUGwI0_CVNAOw__"